import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { mediaQueries } from 'components/mediaQueries';

type Props = {
  headingText: string;
  children: ReactNode;
};

export const MiniArticleCardContainer = ({ headingText, children }: Props) => {
  return (
    <Outer>
      <Heading>{headingText}</Heading>
      {children}
    </Outer>
  );
};

const Outer = styled.section`
  display: grid;
  grid-row-gap: 30px;
  padding: 0 20px;
  place-items: baseline;
  ${mediaQueries.desktop} {
    grid-row-gap: 40px;
    justify-content: center;
    place-items: center;
  }
`;

const Heading = styled.h2`
  font-size: 20px;
  font-weight: 800;
`;
